<template>
	<component
		:is="mTag"
		:class="[baseClass, `text-${color}`]"
		:style="{ '--font-weight': fontWeight }"
		class="base-text"
	>
		<slot></slot>
	</component>
</template>
<script>
import { BaseMixin } from '@/mixins'

export default {
	name: 'BaseText',
	mixins: [BaseMixin],
	props: {
		h1: Boolean,
		h2: Boolean,
		link: Boolean,
		small: Boolean,
		tiny: Boolean,
		text: Boolean,

		bold: Boolean,
		normal: Boolean,
		tag: String,
	},
	data: () => ({
		tags: {
			h1: 'h1',
			h2: 'h2',
			link: 'div',
			small: 'div',
			text: 'div',
			tiny: 'div',
		},
	}),
	computed: {
		baseClass() {
			if (['div', 'text'].includes(this.type)) return ''
			return `base-${this.type}`
		},
		type() {
			return (
				['h1', 'h2', 'text', 'link', 'small', 'tiny'].find(
					(type) => this[type] === true
				) || 'div'
			)
		},
		mTag() {
			return this.tag || this.tags[this.type] || 'div'
		},
		fontWeight() {
			if (this.bold) return 'bold'
			if (this.normal) return 'normal'
			if (['h1', 'h2'].includes(this.type)) return 'bold'
			return 'normal'
		},
	},
}
</script>
<style lang="scss">
.base-text,
.\>\*\:base-text > * {
	font-size: 17px;
	padding-top: 4px;
	line-height: 22px;
	font-weight: var(--font-weight);
	font-family: 'Acumin Pro', sans-serif;
}
.base-h1 {
	font-size: 30px;
	line-height: 40px;
}
.base-h2 {
	font-size: 20px;
	line-height: 27px;
}
.base-link,
.\>\*\:base-link > * {
	cursor: pointer;
	text-decoration: underline;
}
.base-small {
	font-size: 15px;
	line-height: 20px;
}
.base-tiny {
	font-size: 13px;
	line-height: 17px;
}
</style>
